module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav"
  }, [_c('div', {
    staticClass: "nav-wrapper"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.back),
      expression: "back"
    }],
    staticClass: "back",
    on: {
      "click": _vm.goBack
    }
  }, [_c('i', {
    staticClass: "icon-back iconfont"
  })]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.close) ? _c('span', {
    staticClass: "btn-img close",
    on: {
      "click": _vm.closeAcountAction
    }
  }, [_c('span', {
    staticClass: "iconfont icon-zhuxiao"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('basic.close')))])]) : _vm._e()])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-eac0da56", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eac0da56"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav/nav.vue
// module id = 164
// module chunks = 1 2